export const site = {
  name: 'Home Repair MD',
  phone: '(702) 696-8172',
  phoneHref: 'tel:+17026968172',
  license: 'NV Licensed Contractor #0093347',
  city: 'Las Vegas',
  location: 'North Las Vegas, NV 89084',
  serviceAreas: [
    'Las Vegas',
    'Henderson',
    'Summerlin',
    'North Las Vegas',
    'Spring Valley',
    'Enterprise',
    'Paradise',
    'Boulder City',
  ],
}

export const navLinks = [
  { label: 'Our Work', to: '/#work' },
  { label: 'Reviews', to: '/reviews' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

export const whyChooseUs = [
  'Years of experience',
  'Fully insured',
  'Cost control experts',
  'Free consultation',
  'Satisfied customers',
  'Project management',
  'Affordable pricing',
  'Reliability that respects your family’s time',
]

export const aboutCopy = {
  story: [
    'Home Repair MD is a local, family-owned business with many years of construction experience. We started our own business because we love what we do — and our love for our hometown keeps us dedicated to bringing quality, affordable home maintenance and repair to Las Vegas.',
    'Our clients get dependable results thanks to our professional quality-assurance policy, the foundation of how efficiently we work. We hold ourselves to high standards and keep improving our tools and technology to meet them.',
  ],
  philosophy: [
    'Our philosophy is simple: we treat customers the way we want to be treated — with kindness, courtesy, respect and communication. We’re a little old-school that way.',
    'We do what we say we’ll do. We show up as scheduled. We clean up after ourselves. We keep you updated on your project, and we finish on time and on budget. And when the job is done, we’re not happy until you’re completely satisfied with our work.',
    'We consider ourselves craftsmen and take pride in every project, but we also know not every job is the same. If you have a budget you’re trying to stay within, tell us — we’ll do our best to work with it.',
  ],
}

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/81603fe7-d123-4dff-8f82-65becff9a5e7.jpg',
  before: 'https://cdn.magicpatterns.com/patterns/generated-images/d38576b1-cb68-4acd-bc76-53eb40fcfb1d.jpg',
  after: 'https://cdn.magicpatterns.com/patterns/generated-images/56bc93b7-2cdc-496b-8c69-f9a37016846c.jpg',
  team: 'https://cdn.magicpatterns.com/patterns/generated-images/78840a29-81ea-4a8e-9968-39ee5b047891.jpg',
  flooring: 'https://cdn.magicpatterns.com/patterns/generated-images/d3c00346-3429-4a2f-8625-2bfd0c2b4ddc.jpg',
}
